// extracted by mini-css-extract-plugin
export var ctaWrapper = "videoCarousel-module--ctaWrapper--143fe";
export var header = "videoCarousel-module--header--47e62";
export var quote = "videoCarousel-module--quote--b6c68";
export var video = "videoCarousel-module--video--dd9f4";
export var videoList = "videoCarousel-module--videoList--309e2";
export var wrapper = "videoCarousel-module--wrapper--4c55c";
export var youtubePlayer = "videoCarousel-module--youtubePlayer--a7011";
export var youtubePlayerContainer = "videoCarousel-module--youtubePlayerContainer--f2210";